<template>
  <div :class="classes">
    <div class="content">
        <k-icon-button
          type="left1"
          class="btn-close"
          @click.native="close()"
        />

      <div class="header">
        <h4>Notificações</h4>
      </div>
      <NotificationsList
        v-if="opened"
        @close="close()"
      />
    </div>
  </div>
</template>

<script>
import { KIconButton } from '@/components/KaledoComponents'
import NotificationsList from '@/components/Notifications/NotificationsList'
import { LAYOUT_NOTIFICATIONS, NOTIFICATIONS, LAYOUT_CLOSE } from '@store/types'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    KIconButton,
    NotificationsList
  },

  computed: {
    ...mapGetters({
      opened: LAYOUT_NOTIFICATIONS,
      notifications: NOTIFICATIONS
    }),

    classes () {
      const classes = [
        'layout-notifications-sidebar', {
          '-opened': this.opened
        }]
      return classes
    }
  },

  mounted () {
    this.close()
  },

  methods: {
    ...mapActions({
      close: LAYOUT_CLOSE
    })
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.layout-notifications-sidebar {
  background-color: #F8F8FD;
  z-index: 12;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  height: 100vh;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  will-change: transform;
  max-width: 100%;

  & > .content {
    flex: 100%;
    overflow-y: scroll;
    & > .header h4 {
      height: 70px;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: rgba(18, 30, 72, 0.8);
      text-transform: uppercase;
      font-family: 'Nunito Sans';
    }
    & > .btn-close {
      position: fixed;
      top: 15px;
      left: 10px;
    }
  }

  &.-opened {
    transform: translateX(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Layout/NotificationsSidebar.vue